import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Batch Report")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Phase", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "col-md-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Institute", -1)
const _hoisted_16 = { class: "col-md-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Course", -1)
const _hoisted_18 = { class: "col-md-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Batch", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = { class: "col-md-2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Gender", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = { class: "col-md-2 mt-2" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_26 = { key: 0 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h4", { class: "mt-6" }, "Enrollment Summary", -1)
const _hoisted_28 = { class: "card p-3 mb-5 position-relative" }
const _hoisted_29 = { class: "row m-0" }
const _hoisted_30 = { class: "col bg-light-success d-flex align-items-center px-6 py-8 rounded-2 me-4" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x svg-icon-success d-block my-2 col-md-3 mr-3 w-50" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-users fs-3x text-success" })
], -1)
const _hoisted_33 = { class: "col mt-5" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "text-success fw-bold fs-6 mt-2" }, "TOTAL TRAINEES", -1)
const _hoisted_35 = { class: "col bg-light-danger d-flex align-items-center px-6 py-8 rounded-2 me-4" }
const _hoisted_36 = { class: "row" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "d-block my-2 col-md-3 mr-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-female fs-3x text-danger" })
], -1)
const _hoisted_38 = { class: "col mt-5" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger fw-bold fs-6 mt-2" }, "FEMALE TRAINEES ", -1)
const _hoisted_40 = { class: "col bg-light-success d-flex align-items-center px-6 py-8 rounded-2 me-4" }
const _hoisted_41 = { class: "row" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "d-block my-2 col-md-3 mr-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-wheelchair fs-3x text-success" })
], -1)
const _hoisted_43 = { class: "col mt-5" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "text-success fw-bold fs-6 mt-2" }, "DISADVANTAGED TRAINEES ", -1)
const _hoisted_45 = { class: "col bg-light-info d-flex align-items-center px-6 py-8 rounded-2 me-4" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "d-block my-2 col-md-3 mr-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-briefcase fs-3x text-info" })
], -1)
const _hoisted_48 = { class: "col mt-5 ml-3" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "text-info fw-bold fs-7 mt-2" }, "HAVE EMPLOYMENT ", -1)
const _hoisted_50 = { class: "col bg-light-danger d-flex align-items-center px-6 py-8 rounded-2 me-4" }
const _hoisted_51 = { class: "row mb-5" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("span", { class: "d-block my-2 col-md-3 mr-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map fs-3x text-danger" })
], -1)
const _hoisted_53 = { class: "col mt-5 ml-3" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger fw-bold fs-7 mt-2" }, "HAVE LAND", -1)
const _hoisted_55 = { class: "col bg-light-info d-flex align-items-center px-6 py-8 rounded-2 me-4" }
const _hoisted_56 = { class: "row mb-5" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", { class: "d-block my-2 col-md-3 mr-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-home fs-3x text-info" })
], -1)
const _hoisted_58 = { class: "col mt-5 ml-3" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("span", { class: "text-info fw-bold fs-7 mt-2" }, "HAVE HOME", -1)
const _hoisted_60 = { class: "col bg-light-success d-flex align-items-center px-6 py-8 rounded-2" }
const _hoisted_61 = { class: "row" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("span", { class: "d-block my-2 col-md-3 mr-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map-marked fs-3x text-info" })
], -1)
const _hoisted_63 = { class: "col mt-5 ml-3" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("span", { class: "text-info fw-bold fs-7 mt-2" }, "HAVE BOTH LAND AND HOME", -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("h4", { class: "mt-4" }, "Training day and Trainers", -1)
const _hoisted_66 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_67 = { class: "collapse show" }
const _hoisted_68 = { class: "card-body border-top p-6" }
const _hoisted_69 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_70 = { class: "mb-4" }
const _hoisted_71 = { class: "table-responsive mt-5" }
const _hoisted_72 = { class: "table table-borderless gy-4" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle" }, [
    /*#__PURE__*/_createElementVNode("th", { style: {"color":"black"} }, "Training Day"),
    /*#__PURE__*/_createElementVNode("th", { style: {"color":"black"} }, "Training Location"),
    /*#__PURE__*/_createElementVNode("th", { style: {"color":"black"} }, "Start Time"),
    /*#__PURE__*/_createElementVNode("th", { style: {"color":"black"} }, "End Time"),
    /*#__PURE__*/_createElementVNode("th", { style: {"color":"black"} }, "Lead Trainer"),
    /*#__PURE__*/_createElementVNode("th", { style: {"color":"black"} }, "Name"),
    /*#__PURE__*/_createElementVNode("th", { style: {"color":"black"} }, "Associate Trainer"),
    /*#__PURE__*/_createElementVNode("th", { style: {"color":"black"} }, "Name")
  ])
], -1)
const _hoisted_74 = { style: {} }
const _hoisted_75 = { class: "align-middle" }
const _hoisted_76 = { class: "align-middle" }
const _hoisted_77 = { class: "align-middle" }
const _hoisted_78 = { class: "align-middle" }
const _hoisted_79 = { class: "align-middle" }
const _hoisted_80 = ["src"]
const _hoisted_81 = {
  key: 1,
  style: {"width":"50px"},
  src: "\r\n                                            media/avatars/blank.png\r\n                                          "
}
const _hoisted_82 = { class: "align-middle" }
const _hoisted_83 = { class: "align-middle" }
const _hoisted_84 = ["src"]
const _hoisted_85 = {
  key: 1,
  style: {"width":"50px"},
  src: "\r\n                                            media/avatars/blank.png\r\n                                          "
}
const _hoisted_86 = { class: "align-middle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Form = _resolveComponent("Form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _cache[8] || (_cache[8] = ($event: any) => (_ctx.formSubmit())),
    class: "form",
    "validation-schema": _ctx.AssociationSchema
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _hoisted_10,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      name: "tranche_id",
                      placeholder: "Select Phase",
                      modelValue: _ctx.batch.tranche_id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches_info, (tranche) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: tranche.id,
                            label: tranche.label,
                            value: tranche.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(tranche.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _hoisted_13,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Training Partner",
                      name: "entity_id",
                      modelValue: _ctx.batch.entity_id,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.entity_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"},
                      onChange: _ctx.getTrainingInstitute
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (info) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: info.id,
                            label: 
                        '[' + info.entity_short_name + '] - ' + info.entity_name
                      ,
                            value: info.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString('[' + info.entity_short_name + '] - ' + info.entity_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Institute",
                      modelValue: _ctx.batch.institute_id,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.batch.institute_id) = $event)),
                      name: "institute_id",
                      filterable: "",
                      style: {"width":"100%"},
                      onChange: _ctx.courseInfo
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instituteList, (info) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: info.id,
                            label: info.short_name,
                            value: info.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(info.institute_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Course",
                      modelValue: _ctx.batch.course_id,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.batch.course_id) = $event)),
                      name: "course_id",
                      filterable: "",
                      style: {"width":"100%"},
                      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.batchInfo()))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseList, (info) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: info.id,
                            label: info.course_name,
                            value: info.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(info.course_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _hoisted_20,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Batch",
                      modelValue: _ctx.batch.batch_id,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.batch.batch_id) = $event)),
                      name: "batch_id",
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.batchList, (info) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: info.id,
                            label: info.batch_sequence_number,
                            value: info.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(info.batch_sequence_number), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _hoisted_23,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Gender",
                      modelValue: _ctx.batch.gender,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.batch.gender) = $event)),
                      style: {"width":"100%"},
                      onChange: _ctx.btnCheckStatus
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          value: "male",
                          label: "Male"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Male")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          value: "female",
                          label: "Female"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Female")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("button", {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showDetails())),
                      type: "button",
                      class: "btn btn-success mt-6 p-3",
                      style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                    }, [
                      _createTextVNode(" Search "),
                      _hoisted_25
                    ])
                  ])
                ]),
                (_ctx.showCourseNotice)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _hoisted_27,
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _hoisted_32,
                              _createElementVNode("h4", _hoisted_33, _toDisplayString(_ctx.detailsData?.total_trainee), 1),
                              _hoisted_34
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("div", _hoisted_36, [
                              _hoisted_37,
                              _createElementVNode("h4", _hoisted_38, _toDisplayString(_ctx.detailsData?.female_trainee), 1),
                              _hoisted_39
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("div", _hoisted_41, [
                              _hoisted_42,
                              _createElementVNode("h4", _hoisted_43, _toDisplayString(_ctx.detailsData?.disadvantage_trainee), 1),
                              _hoisted_44
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("div", _hoisted_46, [
                              _hoisted_47,
                              _createElementVNode("h4", _hoisted_48, _toDisplayString(_ctx.detailsData?.employed), 1),
                              _hoisted_49
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_50, [
                            _createElementVNode("div", _hoisted_51, [
                              _hoisted_52,
                              _createElementVNode("h4", _hoisted_53, _toDisplayString(_ctx.detailsData?.have_land), 1),
                              _hoisted_54
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_55, [
                            _createElementVNode("div", _hoisted_56, [
                              _hoisted_57,
                              _createElementVNode("h4", _hoisted_58, _toDisplayString(_ctx.detailsData?.have_home), 1),
                              _hoisted_59
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_60, [
                            _createElementVNode("div", _hoisted_61, [
                              _hoisted_62,
                              _createElementVNode("h4", _hoisted_63, _toDisplayString(_ctx.detailsData?.have_both_home_land), 1),
                              _hoisted_64
                            ])
                          ])
                        ])
                      ]),
                      _hoisted_65,
                      (_openBlock(), _createElementBlock("div", {
                        class: "card mb-5 mb-xl-10",
                        key: _ctx.componentKey
                      }, [
                        _createElementVNode("div", _hoisted_66, [
                          _createElementVNode("div", _hoisted_67, [
                            _createElementVNode("div", _hoisted_68, [
                              _createElementVNode("div", _hoisted_69, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.batchDetails, (info, inx) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, { key: inx }, [
                                    _createElementVNode("h4", _hoisted_70, "Term-" + _toDisplayString(inx), 1),
                                    _createElementVNode("div", _hoisted_71, [
                                      _createElementVNode("table", _hoisted_72, [
                                        _hoisted_73,
                                        _createElementVNode("tbody", _hoisted_74, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info, (data, index) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                              key: index,
                                              style: {"border-bottom":"1px solid\r\n                                          rgba(29, 182, 140, 0.51)"}
                                            }, [
                                              _createElementVNode("td", _hoisted_75, _toDisplayString(data?.training_day), 1),
                                              _createElementVNode("td", _hoisted_76, _toDisplayString(data?.training_location), 1),
                                              _createElementVNode("td", _hoisted_77, _toDisplayString(_ctx.moment(
                                            data?.start_time,
                                            'hh:mm'
                                          ).format('LT')), 1),
                                              _createElementVNode("td", _hoisted_78, _toDisplayString(_ctx.moment(
                                            data?.end_time,
                                            'hh:mm'
                                          ).format('LT')), 1),
                                              _createElementVNode("td", _hoisted_79, [
                                                (
                                            data?.master_trainer_info
                                              ?.attach_file_info
                                          )
                                                  ? (_openBlock(), _createElementBlock("img", {
                                                      key: 0,
                                                      style: {"width":"50px"},
                                                      src: 
                                            _ctx.api_url +
                                            data?.master_trainer_info
                                              ?.attach_file_info?.file_path
                                          
                                                    }, null, 8, _hoisted_80))
                                                  : (_openBlock(), _createElementBlock("img", _hoisted_81))
                                              ]),
                                              _createElementVNode("td", _hoisted_82, _toDisplayString(data?.master_trainer_info
                                            ?.employee_info?.name), 1),
                                              _createElementVNode("td", _hoisted_83, [
                                                (
                                            data?.associate_trainer_info
                                              ?.attach_file_info
                                          )
                                                  ? (_openBlock(), _createElementBlock("img", {
                                                      key: 0,
                                                      style: {"width":"50px"},
                                                      src: 
                                            _ctx.api_url +
                                            data?.associate_trainer_info
                                              ?.attach_file_info?.file_path
                                          
                                                    }, null, 8, _hoisted_84))
                                                  : (_openBlock(), _createElementBlock("img", _hoisted_85))
                                              ]),
                                              _createElementVNode("td", _hoisted_86, _toDisplayString(data?.associate_trainer_info
                                            ?.employee_info?.name), 1)
                                            ]))
                                          }), 128))
                                        ])
                                      ])
                                    ])
                                  ], 64))
                                }), 128))
                              ])
                            ])
                          ])
                        ])
                      ]))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}